import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import '../styles/LoginGateModal.css';

/**
 * Friendly login prompt shown when an anonymous user tries to Save or Export
 * on the Pro Calculator. Their in-progress work is preserved (the calculator
 * state is persisted to localStorage), so logging in brings them right back.
 */
const LoginGateModal = ({ open, onClose, action = 'save and export', subtitle }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const go = (tab) => {
    try { localStorage.setItem('postLoginRedirect', '/pro'); } catch { /* noop */ }
    navigate(`/login?redirect=/pro${tab === 'signup' ? '&tab=signup' : ''}`);
  };

  return (
    <div className="login-gate-overlay" onClick={onClose}>
      <div
        className="login-gate-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="login-gate-title"
      >
        <button className="login-gate-close" onClick={onClose} aria-label="Close">×</button>
        <div className="login-gate-icon"><Lock size={32} aria-hidden="true" /></div>
        <h2 id="login-gate-title" className="login-gate-title">Log in or create a free account to {action}</h2>
        <p className="login-gate-text">
          {subtitle || <>It only takes a few seconds, and <strong>your current work will stay right here</strong> so you can pick up exactly where you left off.</>}
        </p>
        <div className="login-gate-buttons">
          <button className="login-gate-btn primary" onClick={() => go('signup')}>
            Sign Up Free
          </button>
          <button className="login-gate-btn secondary" onClick={() => go('login')}>
            Log In
          </button>
        </div>
        <button className="login-gate-keep" onClick={onClose}>
          Keep working without saving
        </button>
      </div>
    </div>
  );
};

export default LoginGateModal;
